import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ButtonContained } from '@/UI/Buttons/AppButton';
import { TextLgMd, TextSmRg } from '@/UI/AppTypography/AppTypography';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';

type ApiKeyDeleteConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
};

export const ApiKeyDeleteConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
}: ApiKeyDeleteConfirmationModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : onClose}
      fullWidth
      maxWidth="xs"
      slotProps={{
        paper: {
          sx: {
            backgroundColor: color.Black92,
            backgroundImage: 'none',
            borderRadius: 2,
            p: 0.5,
          },
        },
      }}
    >
      <DialogTitle sx={{ pr: 6 }}>
        <TextLgMd>{t(I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_CONFIRM.TITLE)}</TextLgMd>
        <IconButton
          aria-label={t(I18N_KEYS.GENERAL.CLOSE)}
          onClick={onClose}
          disabled={isLoading}
          sx={{ position: 'absolute', right: 12, top: 12, color: color.White64_T }}
        >
          <i className="fa-light fa-xmark" style={{ fontSize: 16 }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <TextSmRg color={color.White80_T}>
          {t(I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_CONFIRM.BODY)}
        </TextSmRg>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
        <ButtonContained size="small" mode="text" onClick={onClose} disabled={isLoading}>
          {t(I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_CONFIRM.CANCEL)}
        </ButtonContained>
        <ButtonContained size="small" onClick={onConfirm} disabled={isLoading}>
          {t(I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_CONFIRM.CONFIRM)}
        </ButtonContained>
      </DialogActions>
    </Dialog>
  );
};
